import Cookies from "universal-cookie";
import packageJson from "../../package.json";
import { AES, enc } from "crypto-js";
import Log from "../components/Analytics/Equity/Log";
const cookies = new Cookies();

const secretKey = btoa(process.env.REACT_APP_API_KEY); // Secret key is nothing but base64 conversion of api key.

const encryptCookies = true; // This flag is to toggle encryption, so no need to deep dive in code in case we want to test without encryption.

export const setCookie = (key, value) => {
  try {
    const encryptedValue = encryptCookies
      ? AES.encrypt(JSON.stringify(value), secretKey).toString()
      : value;
    cookies.set(key, encryptedValue, {
      expires: 0,
      path: `${packageJson?.homepage}`,
      secure: window.location.host === "sandbox.catalystmi.com" ? false : true,
      sameSite: "strict",
    });
  } catch (error) {
    Log("Error", error);
  }
};

export const getAllCookies = () => {
  return cookies.getAll();
};

export const getCookie = (key) => {
  try {
    const value = cookies.get(key);
    if (encryptCookies) {
      const decrypted = value
        ? AES.decrypt(value, secretKey).toString(enc.Utf8)
        : undefined;
      const parsed = isValidJSON(decrypted) ? JSON.parse(decrypted) : decrypted; // if its valid JSON then converting to JSON
      const parsed2 = isValidJSON(parsed) ? JSON.parse(parsed) : parsed;
      const str = ["boolean", "number"].includes(typeof parsed2)
        ? JSON.stringify(parsed2)
        : parsed2;
      return str;
    }
    return value;
  } catch (error) {
    Log(`Error : ${error}`);
  }
};

export const deleteCookie = (key) => {
  cookies.remove(key, {
    expires: 0,
    path: `${packageJson?.homepage}`,
    secure: true,
    sameSite: "strict",
  });
};

export function isValidJSON(jsonString) {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (error) {
    return false;
  }
}
